<a [href]="excelUrl" download={{downloadFileName}} style="display:none;" #excelAnchor></a>